import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Alert } from "@remo-co/ui-core/src/components/Alert";
import { useSelector } from "react-redux";
import { selectCurrentEventCompanyPlan } from "modules/event/selectors";
import { getRemainingTrialDays } from "modules/companyPlanSettings/utils/trial";
import { selectIsMobile } from "modules/deviceInfo";

export const InEventTrialBanner = (): JSX.Element | null => {
  const { t } = useI18n(["event"]);
  const isMobileView = useSelector(selectIsMobile);
  const eventCompanyPlan = useSelector(selectCurrentEventCompanyPlan);
  const trialLeft = getRemainingTrialDays(eventCompanyPlan);

  if (!isMobileView && trialLeft) {
    return (
      <Alert severity="warning">
        <Typography component="span" color="inherit">
          {t("trial.event")}
        </Typography>
      </Alert>
    );
  }

  return null;
};
